<script lang="ts">
  import type { Track } from '../../services/jitsi-service';
  import { onDestroy, afterUpdate } from 'svelte';
  import logger from '../../utils/logger';

  export let track: Track;

  let audioElement: HTMLAudioElement;
  let attachedTrack: any = null;

  afterUpdate(() => {
    if (!audioElement || !track?.track) return;
    if (attachedTrack !== track.track) {
      attach(track.track);
    }
  });

  onDestroy(() => {
    detach();
  });

  function attach(jitsiTrack: any) {
    detach();
    attachedTrack = jitsiTrack;
    if (!audioElement || !jitsiTrack) return;
    jitsiTrack.attach(audioElement);
    logger.info('Attach audio track');
    void playAudio();
  }

  function detach() {
    if (attachedTrack && audioElement) {
      try {
        attachedTrack.detach(audioElement);
        logger.info('Detach audio track');
      } catch (e) {
        logger.warn('Failed to detach audio track', e as Error);
      }
    }
    attachedTrack = null;
  }

  async function playAudio() {
    if (!audioElement) return;
    try {
      await audioElement.play();
    } catch (e) {
      logger.warn('Audio play() failed', e as Error);
    }
  }

  function onPause() {
    const mediaStreamTrack = track.track?.getTrack?.();
    if (mediaStreamTrack?.readyState === 'ended') return;
    void playAudio();
  }
</script>

<audio bind:this={audioElement} autoplay id="audio-{track.participantId}" on:pause={onPause} />
